import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/blank",
    exact: true,
    component: lazy(() => import("../../pages/blank")),
    layout: "FullLayout",
    pageType: "public",
  },


  {
    path: "/help",
    exact: true,
    component: lazy(() => import("../../pages/Help/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
  {
    path: "/help/baseline",
    exact: true,
    component: lazy(() => import("../../pages/Help/HelpVideoPage")),
    layout: "FullLayout",
    pageType: "public",
  },
  {
    path: "/help/14thday",
    exact: true,
    component: lazy(() => import("../../pages/Help/HelpVideoPage")),
    layout: "FullLayout",
    pageType: "public",
  },
  {
    path: "/help/90thday",
    exact: true,
    component: lazy(() => import("../../pages/Help/HelpVideoPage")),
    layout: "FullLayout",
    pageType: "public",
  },

  {
    path: "/patientfirstVisit",
    exact: true,
    component: lazy(() => import("../../pages/AddPatient/Index")),
    layout: "FullLayout",
    pageType: "public",
  },

  




    {
    path: "/doctordashboard",
    exact: true,
    component: lazy(() => import("../../pages/Dashboard/Index")),
    layout: "FullLayout",
    pageType: "public",
  },

    {
    path: "/addvisists",
    exact: true,
    component: lazy(() => import("../../pages/AddPatient/AddVisits/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/doctorpatientlist",
    exact: true,
    component: lazy(() => import("../../pages/PatientList/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/mydoctorslist",
    exact: true,
    component: lazy(() => import("../../pages/MyDoctors/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/reportsection",
    exact: true,
    component: lazy(() => import("../../pages/Report/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/viewpatientdetails",
    exact: true,
    component: lazy(() => import("../../pages/ViewVistdetail/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/sarthiPatientlist",
    exact: true,
    component: lazy(() => import("../../pages/Sarthi/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/sarthipatientform",
    exact: true,
    component: lazy(() => import("../../pages/Sarthi/AddVisitreportData/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    
    {
    path: "/hodashboard",
    exact: true,
    component: lazy(() => import("../../pages/Dashboards/HODashboard/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/smdashboard",
    exact: true,
    component: lazy(() => import("../../pages/Dashboards/SMDashboard/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/bedashboard",
    exact: true,
    component: lazy(() => import("../../pages/Dashboards/BEDashboard/Index")),
    layout: "FullLayout",
    pageType: "public",
  },
    {
    path: "/editform",
    exact: true,
    component: lazy(() => import("../../pages/Dashboards/HOEditRights/Index")),
    layout: "FullLayout",
    pageType: "public",
  },


 




  //  {
  //   path: "/usermangemnt",
  //   exact: true,
  //   component: lazy(() => import("../../pages/UserMangement/Index")),
  //   layout: "FullLayout",
  //   pageType: "private",
  // },
  {
    path: "/login",
    component: lazy(() => import("../../pages/authentication/login")),
    layout: "FullLayout",
    pageType: "authentication",
  },
    {
    path: "/",
    component: lazy(() => import("../../pages/authentication/login")),
    layout: "FullLayout",
    pageType: "authentication",
  },

  


// {
//   path: "/patientlist",
//   exact: true,
//   component: lazy(() => import("../../pages/Patient/Index")),
//   layout: "FullLayout",
//   pageType: "private",
// },


];

export default PagesRoutes;
